import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
    ContentCardElementContext,
    ContentElementComponent,
} from '@app/shared-modules/content-view/models';
import { ContentElement } from '@libs/models';

@Component({
    selector: 'app-content-card-element',
    templateUrl: './content-card-element.component.html',
    styleUrls: ['./content-card-element.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentCardElementComponent implements ContentElementComponent {
    @Input() element: ContentElement<ContentCardElementContext>;
}
